var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "form",
    {
      staticClass: "servicefinder-location-form",
      attrs: { method: "POST", action: _vm.servicefinder.mapPageUrl },
    },
    [
      _c("div", { staticClass: "wp-block-columns is-layout-flex" }, [
        _c("div", { staticClass: "wp-block-column" }, [
          _c("input", {
            directives: [
              {
                name: "model",
                rawName: "v-model",
                value: _vm.maps.address,
                expression: "maps.address",
              },
            ],
            attrs: {
              type: "text",
              id: "address",
              placeholder: _vm.servicefinder.labels.placeholder,
            },
            domProps: { value: _vm.maps.address },
            on: {
              input: function ($event) {
                if ($event.target.composing) return
                _vm.$set(_vm.maps, "address", $event.target.value)
              },
            },
          }),
        ]),
        _vm._v(" "),
        _c(
          "div",
          {
            staticClass: "wp-block-column",
            staticStyle: { "flex-basis": "auto" },
          },
          [
            _c("div", { staticClass: "wp-block-buttons" }, [
              _c("div", { staticClass: "wp-block-button" }, [
                _c("input", {
                  staticClass: "wp-block-button__link has-medium-font-size",
                  attrs: { type: "submit" },
                  domProps: { value: _vm.servicefinder.labels.search },
                  on: { click: _vm.submitForm },
                }),
              ]),
            ]),
          ]
        ),
      ]),
      _vm._v(" "),
      _c("input", {
        attrs: { type: "hidden", name: "lat" },
        domProps: { value: _vm.lat },
      }),
      _vm._v(" "),
      _c("input", {
        attrs: { type: "hidden", name: "lng" },
        domProps: { value: _vm.lng },
      }),
      _vm._v(" "),
      _c("input", {
        attrs: { type: "hidden", name: "address" },
        domProps: { value: _vm.maps.address },
      }),
      _vm._v(" "),
      _c("input", {
        attrs: { type: "hidden", name: "action", value: "servicefinder" },
      }),
    ]
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }